import { InputGroup } from '../../../common/components/fields/InputGroup'
import { MultilineSearchInput } from '../../../common/components/multiline-input/MultilineSearchInput'
import { ChangeEvent } from 'react'
import { ShippingPointsAutocomplete } from '../../../common/components/Autocomplete/ShippingPointsAutocomplete'
import { getSelectedShippingPoints, getShippingPoints } from '../../shipment/ShippingPoints'

export function OrderSearchInputs({ inputState, setInputState }) {
  function updateTextAreaSearchParameter(event: ChangeEvent<HTMLTextAreaElement>) {
    const newInputState = {
      ...inputState,
      [event.target.name]: event.target.value,
    }
    setInputState(newInputState)
  }

  function updateSelectedShippingPointCodes(_, value) {
    setInputState((prevState) => ({
      ...prevState,
      shippingPointCodes: value.map((o) => o.value).join(','),
    }))
  }

  return (
    <div
      className="flex-column content-center justify-items-start"
      style={{ gap: 'var(--eds-space-8)' }}
    >
      <InputGroup label="Delivery Notes" clearable={false} withDivider={false}>
        <MultilineSearchInput
          name="deliveryNoteNumbers"
          label=""
          value={inputState.deliveryNoteNumbers}
          onChange={updateTextAreaSearchParameter}
        />
      </InputGroup>

      <InputGroup label="Sales Orders" clearable={false} withDivider={false}>
        <MultilineSearchInput
          name="salesOrderNumbers"
          label=""
          value={inputState.salesOrderNumbers}
          onChange={updateTextAreaSearchParameter}
        />
      </InputGroup>

      <InputGroup label="Shipping Points" clearable={false} withDivider={false}>
        <ShippingPointsAutocomplete
          name={'shippingPoints'}
          shippingPointData={getShippingPoints()}
          selectedShippingPoints={getSelectedShippingPoints(inputState.shippingPointCodes)}
          onChange={updateSelectedShippingPointCodes}
        />
      </InputGroup>

      <InputGroup label="Ship To Numbers" clearable={false} withDivider={false}>
        <MultilineSearchInput
          name="shipToCodes"
          label=""
          value={inputState.shipToCodes}
          onChange={updateTextAreaSearchParameter}
        />
      </InputGroup>
    </div>
  )
}
